import { render, staticRenderFns } from "./CallContent.vue?vue&type=template&id=af3c54c4&scoped=true"
import script from "./CallContent.vue?vue&type=script&lang=js"
export * from "./CallContent.vue?vue&type=script&lang=js"
import style0 from "./CallContent.vue?vue&type=style&index=0&id=af3c54c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3c54c4",
  null
  
)

export default component.exports